var _clipPath, _clipPath2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVetoken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 2654 1494",
    width: "339px",
    height: "356px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m534.319 1656.24h2653.61v1493.37h-2653.61z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1393.12 1572.28c-2.77-1.19-4.4-4.09-3.99-7.08.42-2.98 2.79-5.32 5.78-5.71 53.71-7.41 180.39-30.47 312.62-94.74 8.36-4.06 17.04-7.43 25.95-10.08 51.32-14.96 231.75-65.17 344.64-65.42 5.05.01 9.7 2.75 12.15 7.16 2.46 4.41 2.33 9.81-.33 14.1-21.41 34.93-65.68 109.21-99.23 179.5-63.24 132.51-146.44 186.21-183.17 198.08s-157.18 52.95-262.85-90.34c0 0-46.16-80.38-151.57-125.47z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-534.32 -1656.239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m534.319 1656.24h2653.61v1493.37h-2653.61z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.61196 0 0 3.61196 -4406.39 -3361.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1393.12 1572.28c-2.77-1.19-4.4-4.09-3.99-7.08.42-2.98 2.79-5.32 5.78-5.71 53.71-7.41 180.39-30.47 312.62-94.74 8.36-4.06 17.04-7.43 25.95-10.08 51.32-14.96 231.75-65.17 344.64-65.42 5.05.01 9.7 2.75 12.15 7.16 2.46 4.41 2.33 9.81-.33 14.1-21.41 34.93-65.68 109.21-99.23 179.5-63.24 132.51-146.44 186.21-183.17 198.08s-157.18 52.95-262.85-90.34c0 0-46.16-80.38-151.57-125.47z",
    fill: "#f40041"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1451.89 1699.2-16.8-95.88 692.89-131.29c-43.99 34.5-109.29 91.22-144.24 148.04-67.11 109.1-132.49 151.86-176.2 168.02-64.59 23.87-249.97 54.4-355.65-88.89z",
    fill: "#ff5ca8",
    transform: "translate(-83.3701 -124.396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1384.37 1681.84 12.97-40.81 621.46 73.87c-91.69 27.79-183.48 62.92-211.26 73.19-64.59 23.87-317.5 37.04-423.17-106.25z",
    fill: "#f29fff",
    transform: "matrix(.953066 -.302762 .302762 .953066 -529.606 366.102)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0400fd",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1619.27 1478.93s227.49-67.45 470.33 16.74l-217.07 381.55-495.67 41.66-36.04-403.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1549.41 1495.67s263.2-.02 422.48 205.87l-233.83 151.82-410.37-63.18 15.88-243.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1439.82 1532.42s321.29 77.57 364.07 338.21l-290.84-34.42-238.75-133.85 8.99-158.07z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetoken);
export default __webpack_public_path__ + "static/media/vetoken.9b4315677a31bf0df238168ab9107e6b.svg";
export { ForwardRef as ReactComponent };